/* unplugin-vue-components disabled */import script from "./CouponDetailDesc.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDetailDesc.vue?vue&type=script&setup=true&lang=js"

import "./CouponDetailDesc.vue?vue&type=style&index=0&id=7893c336&lang=scss"

const __exports__ = script;

export default __exports__